import { GET_EVENT_FS_OBJECT_CHILDREN } from 'actions/Types';
import { eventChanged } from './utils';
import { matchPath } from 'react-router';
import Paths from 'AppPaths';

import { applyDefaultSortObjectListItems } from 'utils/eventFSObjectSortHelper';

const defaultState = [];

export default (state = defaultState, action) => {
  if (action.type === '@@router/LOCATION_CHANGE') {
    const pathName = action.payload.location.pathname;

    const userMatch = matchPath(pathName, {
      path: Paths.UserDash
    });

    if (userMatch) {
      return defaultState;
    }

    if (eventChanged(pathName, state)) {
      return defaultState;
    }
  }

  const { payload, type } = action;
  if (type === `${GET_EVENT_FS_OBJECT_CHILDREN}_SUCCESS`) {
    const filteredItems = payload.items.filter(item => {
      return item.reference || item.isDirectory;
    });
    return applyDefaultSortObjectListItems(filteredItems);
  }

  return state;
};
